// extracted by mini-css-extract-plugin
export default {"moveMenu":"MoveMenu_moveMenu__xto24","warningText":"MoveMenu_warningText__SmKAt"};